/** CSV 셀 이스케이프 — 수식 주입(=+-@ 등) 방어 포함 */
export function csvEscape(value: unknown): string {
  let text = String(value ?? '')
  if (/^[=+\-@]/.test(text) || text.startsWith('\t') || text.startsWith('\r')) {
    text = `'${text}`
  }
  if (/[",\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`
  return text
}
